import styled from '@emotion/styled';
import React from 'react';
import Text01Img from 'ui/images/article/text_01.svg';

const DescriptionText = styled.p`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 0.96rem;
    line-height: 160%;
    letter-spacing: 0.8px;
    color: #1e4e66;
    margin: 0;
`;

const HighlightText = styled.span`
    font-weight: 700;
    color: #ee793f;
    background-color: #fffbc9;
`;

const SuccessionTypesContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 44px;
    margin-top: 40px;
`;

const SuccessionTypeItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    position: relative;
    overflow: visible;
`;

const CircleWrapper = styled.div`
    position: relative;
    width: 118px;
    height: 119px;
    flex-shrink: 0;
`;

const CircleOutlined = styled.div`
    width: 118px;
    height: 119px;
    border-radius: 50%;
    border: 3px solid #1695d4;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const CircleFilled = styled.div`
    width: 118px;
    height: 119px;
    border-radius: 50%;
    background: #1695d4;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const CircleLabel = styled.div`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 160%;
    letter-spacing: 0.8px;
    color: #1695d4;
    text-align: center;
`;

const CircleLabelWhite = styled(CircleLabel)`
    color: #fff;
`;

const DescriptionLabel = styled.div`
    font-family: 'Zen Kaku Gothic Antique', -apple-system, Roboto, Helvetica, sans-serif;
    font-size: 14px;
    line-height: 160%;
    letter-spacing: 0.7px;
    color: #1e4e66;
    text-align: center;
    white-space: pre-line;
`;

const RecommendedLabel = styled.img`
    position: absolute;
    top: -31px;
    left: 50%;
    transform: translateX(-50%);
    width: 10rem;
    max-width: 200px;
`;

export const MaForBeginnerDerail_1_2: React.FC = () => {
    return (
        <>
            <DescriptionText>
                M&Aの進め方には <HighlightText>「直接取引」</HighlightText>と<HighlightText>「仲介取引」</HighlightText>
                があります。直接取引は、売り手と買い手が自ら交渉し合意に至る方法です。仲介手数料がかからない一方で、条件のすり合わせや契約手続きが複雑になりやすく、専門知識がなければリスクが高まります。一方、仲介取引ではM&A仲介会社やFA（ファイナンシャルアドバイザー）が間に入り、候補先の探索から条件交渉、契約書作成までをサポートします。特に初めてM&Aを経験するオーナーにとって、
                <HighlightText>仲介取引は安心して取引を進められる手段</HighlightText>といえます。
            </DescriptionText>
            <SuccessionTypesContainer>
                <SuccessionTypeItem>
                    <CircleWrapper>
                        <CircleOutlined>
                            <CircleLabel>直接取引</CircleLabel>
                        </CircleOutlined>
                    </CircleWrapper>
                    <DescriptionLabel>{'売り手と買い手が\n自ら交渉する'}</DescriptionLabel>
                </SuccessionTypeItem>
                <SuccessionTypeItem>
                    <RecommendedLabel src={Text01Img} alt="初めてのM&Aでも安心" />
                    <CircleWrapper>
                        <CircleFilled>
                            <CircleLabelWhite>仲介取引</CircleLabelWhite>
                        </CircleFilled>
                    </CircleWrapper>
                    <DescriptionLabel>{'M&A仲介会社や\nFAが間に入る'}</DescriptionLabel>
                </SuccessionTypeItem>
            </SuccessionTypesContainer>
        </>
    );
};
